import { useContext } from 'react';
import { PaymentContext } from 'contexts/payment_context';

const usePayment = () => {
    return useContext(PaymentContext);
};

export default usePayment;
